import React, { useEffect } from "react";
import SectionRenderer from "@/components/site/SectionRenderer";
import SEO from "@/components/site/SEO";
import NotFound from "@/pages/NotFound";
import { useLanguage } from "@/i18n/LanguageContext";
import { bi } from "@/lib/bilingual";
import { useCachedGet } from "@/hooks/useCachedGet";
import PageSkeleton from "@/components/site/PageSkeleton";

/**
 * Renders a system CMS page by route_key (home, about, services, ...).
 * Falls back to NotFound if missing; optional fallbackElement for gradual rollout.
 */
const CmsPage = ({ routeKey, fallback = null }) => {
  const { t, lang } = useLanguage();
  const { data: page, ready } = useCachedGet(`/pages/public-by-route/${routeKey}`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [routeKey]);

  if (!ready) return <PageSkeleton />;

  if (page === false || !page) {
    if (fallback) return fallback;
    return <NotFound />;
  }

  const seoTitle = bi(page.seo_title, lang) || page.title;
  const seoDesc = bi(page.seo_description, lang);

  return (
    <div>
      <SEO title={seoTitle} description={seoDesc} />
      {(page.sections || []).map((s) => (
        <SectionRenderer key={s.id} section={s} />
      ))}
      {(page.sections || []).length === 0 && (
        <div className="pt-40 pb-20 text-center text-zinc-400">Belum ada konten. Edit di Admin → Pages.</div>
      )}
    </div>
  );
};

export default CmsPage;
